import posthog from "posthog-js";

const key = process.env.NEXT_PUBLIC_POSTHOG_KEY;

if (key) {
  posthog.init(key, {
    api_host: "/ingest",
    ui_host:
      process.env.NEXT_PUBLIC_POSTHOG_UI_HOST || "https://us.posthog.com",
    request_batching: true,
    disable_external_dependency_loading: false,
    advanced_disable_flags: false,
    autocapture: {
      dom_event_allowlist: ["click", "change", "submit"],
      element_allowlist: ["a", "button", "form", "input", "select", "textarea"],
      element_attribute_ignorelist: ["value", "placeholder"],
      capture_copied_text: false,
    },
    capture_pageview: false,
    capture_pageleave: true,
    capture_performance: true,
    capture_heatmaps: true,
    capture_dead_clicks: true,
    capture_exceptions: true,
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: "[data-private], .ph-no-capture",
      blockSelector: "[data-ph-block]",
    },
    person_profiles: "identified_only",
    respect_dnt: true,
    before_send(event) {
      const pathname = window.location.pathname;
      if (
        window.localStorage.getItem("hl_staff_analytics_opt_out") === "1" ||
        pathname === "/admin" ||
        pathname.startsWith("/admin/") ||
        pathname === "/login" ||
        pathname === "/register"
      ) {
        return null;
      }
      return event;
    },
  });
}
